(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["card-stack"] && !Shopify.designMode) return;
  try {
    
class CardStack extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('.card-stack__card'));
    this.panels = Array.from(this.querySelectorAll('.card-stack__panel'));
    this.deck = this.querySelector('.card-stack__deck');
    this.count = this.cards.length;
    this.current = 0;
    if (this.count === 0) return;

    this.angles = [0, 4, -5, 7, -3];
    this.ox = [0, 24, -18, 30, -14];
    this.oy = [0, -14, 16, -22, 20];

    this.render();

    this.querySelectorAll('.card-stack__arrow').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.dataset.dir === 'next' ? this.next() : this.prev();
        this.stopAuto();
      });
    });

    this.bindSwipe();
    this.bindKeys();
    this.bindEditor();
    this.startAuto();
  }

  disconnectedCallback() {
    this.stopAuto();
  }

  render() {
    const n = this.count;
    this.cards.forEach((card, i) => {
      const pos = ((i - this.current) % n + n) % n;
      if (pos > 2) {
        card.style.opacity = '0';
        card.style.zIndex = '0';
        card.style.transform = 'translate(0, 0) scale(0.92)';
        card.style.pointerEvents = 'none';
      } else {
        card.style.opacity = '1';
        card.style.zIndex = String(n - pos);
        card.style.transform = `translate(${this.ox[pos] || 0}px, ${this.oy[pos] || 0}px) rotate(${this.angles[pos] || 0}deg)`;
        card.style.pointerEvents = pos === 0 ? 'auto' : 'none';
      }
    });
    this.panels.forEach((p, i) => p.classList.toggle('is-active', i === this.current));
  }

  next() {
    this.current = (this.current + 1) % this.count;
    this.render();
  }

  prev() {
    this.current = (this.current - 1 + this.count) % this.count;
    this.render();
  }

  bindSwipe() {
    if (!this.deck || this.count < 2) return;
    let startX = null;
    let dragging = false;
    let top = null;

    this.deck.addEventListener('pointerdown', (e) => {
      startX = e.clientX;
      dragging = true;
      top = this.cards[this.current];
      top.style.transition = 'none';
      this.deck.setPointerCapture(e.pointerId);
      this.stopAuto();
    });

    this.deck.addEventListener('pointermove', (e) => {
      if (!dragging || !top) return;
      const dx = e.clientX - startX;
      top.style.transform = `translate(${dx}px, ${this.oy[0] || 0}px) rotate(${dx * 0.04}deg)`;
    });

    const end = (e) => {
      if (!dragging) return;
      dragging = false;
      const dx = (e.clientX || startX) - startX;
      if (top) top.style.transition = '';
      if (dx < -60) this.next();
      else if (dx > 60) this.prev();
      else this.render();
    };

    this.deck.addEventListener('pointerup', end);
    this.deck.addEventListener('pointercancel', () => {
      if (!dragging) return;
      dragging = false;
      if (top) top.style.transition = '';
      this.render();
    });
  }

  bindKeys() {
    if (!this.deck) return;
    this.deck.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { this.prev(); this.stopAuto(); }
      if (e.key === 'ArrowRight') { this.next(); this.stopAuto(); }
    });
  }

  bindEditor() {
    this.addEventListener('shopify:block:select', (e) => {
      const panel = e.target.closest('.card-stack__panel');
      if (panel) {
        this.current = parseInt(panel.dataset.index, 10) || 0;
        this.render();
      }
    });
  }

  startAuto() {
    const ms = parseInt(this.dataset.autoplay, 10);
    if (!ms || this.count < 2) return;
    this.timer = setInterval(() => this.next(), ms);
    this.addEventListener('pointerenter', () => this.stopAuto());
  }

  stopAuto() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

if (!customElements.get('card-stack')) {
  customElements.define('card-stack', CardStack);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-features')) {
  customElements.define('product-features', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.product-features__track');
      if (!this.track) return;
      this.items = Array.from(this.track.children);
      this.prev = this.querySelector('[data-pf-prev]');
      this.next = this.querySelector('[data-pf-next]');
      this.dots = Array.from(this.querySelectorAll('[data-pf-dot]'));
      this.gap = 24;
      if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
      if (this.next) this.next.addEventListener('click', () => this.step(1));
      this.dots.forEach((d, i) => d.addEventListener('click', () => { if (this.items[i]) this.items[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' }); }));
      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
    disconnectedCallback() { if (this.track) this.track.removeEventListener('scroll', this.onScroll); }
    itemWidth() { return this.items[0] ? this.items[0].getBoundingClientRect().width + this.gap : this.track.clientWidth; }
    step(dir) { this.track.scrollBy({ left: dir * this.itemWidth(), behavior: 'smooth' }); }
    onScroll() {
      const i = Math.round(this.track.scrollLeft / this.itemWidth());
      this.dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
